/**
 * Users API
 *
 * Public user profiles (other users, read-only).
 * Extracted from the legacy lib/api.ts monolith for #2253 so mobile can
 * consume it via @shared/lib/api/users (contract §1 domain-module pattern).
 *
 * Backend: GET /api/users/:id (backend/src/routes/users.ts) — requireAuth;
 * blocked viewer -> 404 (hides block status), no shared club -> 403.
 */

import { apiGet } from '../api';

// Public profile response for public user endpoints (v0.8.0)
export interface PublicUserProfile {
  id: string;
  public_display_name: string;
  profile_image_url: string | null;
  cover_image_url: string | null; // #1234
  // user_level removed - see #785
  tagline: string | null;
  location: string | null;
  primary_sport: string | null;
  event_count: number; // #1510: past events attended
  club_count: number; // #1510: clubs joined
  created_at: number;
}

export interface PublicUserProfileResponse {
  profile: PublicUserProfile;
}

// Users API calls (public profiles)
export const usersApi = {
  getPublicProfile: (userId: string) =>
    apiGet<PublicUserProfileResponse>(`/users/${userId}`),
};
